import { apiGet } from './http-client'
import { PARTNERS, memberProfile } from '../mock/directory'
import type { Member, MemberProfile, Partner, TreeNode } from '../mock/directory'

/* 「常用 / 外部」目录服务尚未接入真实数据：接口不可用时用本地模拟数据兜底，
   不读取任何历史个人联系人；接口可用后自动以真实数据为准。 */
const DEMO_MINS = [3, 11, 26, 52, 95, 240, 960, 2880]
async function demoRecents(): Promise<Member[]> {
  const members = await apiGet<Member[]>('/api/directory/members')
  return members.slice(0, DEMO_MINS.length).map((m, i) => ({ ...m, lastContactMin: DEMO_MINS[i] }))
}

export const directoryRepo = {
  members: () => apiGet<Member[]>('/api/directory/members'),
  partners: async (): Promise<Partner[]> => {
    try { return await apiGet<Partner[]>('/api/directory/partners') } catch { return PARTNERS }
  },
  orgTree: (rootLabel?: string) => apiGet<TreeNode>('/api/directory/tree', { root: rootLabel }),
  recents: async (): Promise<Member[]> => {
    try { return await apiGet<Member[]>('/api/directory/recents') } catch { return demoRecents().catch(() => []) }
  },
  profile: async (m: Member): Promise<MemberProfile> => {
    try { return await apiGet<MemberProfile>('/api/directory/members/' + encodeURIComponent(m.id) + '/profile') }
    catch (e) { if (m.external) return memberProfile(m); throw e }
  }
}
